
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[itemID]/reviews",
      function () {
        return require("private-next-pages/product/[itemID]/reviews/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[itemID]/reviews"])
      });
    }
  